import { Card, CardBody, SimpleGrid } from '@chakra-ui/react';
import { Address } from '@pelicargo/types';
import { Show } from '@pelicargo/ui';
import { formatPrintedAwb } from '@pelicargo/utils';

import { useCurrentDraft } from '../../../hooks/useCurrentDraft';
import { AddressMatchTag } from './AddressMatchTag';
import { AwbMatchTag } from './AwbMatchTag';
import { Field } from './Field';
import { BookingConfirmationPayload, formatCutoff } from './payload';

type Props = {
  booking: BookingConfirmationPayload | null;
};

/** What the deterministic matcher resolved this email to: request, carrier, quote, AWB. */
export const LinkageCard = ({ booking }: Props) => {
  const { draft } = useCurrentDraft();
  const isGuessedQuote = booking?.quoteLinkage === 'guessed';

  return (
    <Card variant="outline">
      <CardBody>
        <SimpleGrid columns={{ base: 2, md: 4 }} spacing="4">
          <Field
            label="Request"
            value={draft?.request_id ? `R${draft.request_id}` : null}
            to={draft?.request_id ? `/requests/${draft.request_id}/airline` : undefined}
          />
          <Field label="Carrier" value={draft?.provider_id} />
          <Field
            label={isGuessedQuote ? 'Quote (best guess)' : 'Quote'}
            value={draft?.quote_id ? `Q${draft.quote_id}` : null}
            to={
              draft?.quote_id && draft?.request_id
                ? `/requests/${draft.request_id}/airline#Q${draft.quote_id}`
                : undefined
            }
          />
          <Field
            label="AWB"
            value={formatPrintedAwb(booking?.awb)}
            indicator={<AwbMatchTag extractedAwb={booking?.awb ?? null} quoteAwb={draft?.quote?.awb_number ?? null} />}
          />
          <Show if={!!booking?.cutoff}>
            <Field label="Cut-off" value={booking?.cutoff ? formatCutoff(booking.cutoff) : null} />
          </Show>
          <Show if={!!booking?.deliveryAddress}>
            <Field
              label="Delivery address"
              value={booking?.deliveryAddress}
              indicator={
                <AddressMatchTag
                  printedAddress={booking?.deliveryAddress ?? null}
                  quoteAddress={(draft?.quote?.delivery_address as Address | null) ?? null}
                />
              }
            />
          </Show>
        </SimpleGrid>
      </CardBody>
    </Card>
  );
};
